module.exports = __webpack_public_path__ + "img/8.615e4e52.png";